import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import AdminPanel from "@/components/AdminPanel/AdminPanel";
import PublicMap from "@/components/PublicMap/PublicMap";
import AdminMapRealtime from "@/components/AdminMapRealtime/AdminMapRealtime";
import AdminMapHistory from "@/components/AdminMapHistory/AdminMapHistory";
import {AdminRoutes} from "@/components/AdminRoutes/AdminRoutes";

const AdminArea: React.FC = () => {
    return (
        <div className="p-6">
            <h1 className="text-2xl font-bold mb-4">Транспортный мониторинг (административная зона)</h1>
            <Tabs defaultValue="admin-realtime" className="w-full">
                <TabsList className="flex justify-start gap-2">
                    <TabsTrigger value="admin-realtime">Реальное время</TabsTrigger>
                    <TabsTrigger value="admin-history">История</TabsTrigger>
                    <TabsTrigger value="public-map">Публичная карта</TabsTrigger>
                    <TabsTrigger value="admin-devices">Устройства</TabsTrigger>
                    <TabsTrigger value="admin-routes">Маршруты</TabsTrigger>
                </TabsList>


                <TabsContent key="admin-realtime" value="admin-realtime" className="mt-4">
                    <AdminMapRealtime />
                </TabsContent>

                <TabsContent key="admin-history" value="admin-history" className="mt-4">
                    <AdminMapHistory />
                </TabsContent>

                <TabsContent key="public-map" value="public-map" className="mt-4">
                    <PublicMap />
                </TabsContent>

                <TabsContent key="admin-devices" value="admin-devices" className="mt-4">
                    <AdminPanel />
                </TabsContent>

                <TabsContent key="admin-routes" value="admin-routes" className="mt-4">
                    <AdminRoutes />
                </TabsContent>

            </Tabs>
        </div>
    );
};

export default AdminArea;
